module.exports = __webpack_public_path__ + "img/a33.a5ff53bb.svg";